// @mui
import { Box, Card, Paper, Typography, CardHeader, CardContent, CardProps } from '@mui/material';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';

import useLocales from 'src/hooks/useLocales';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  list?: {
    id: number;
    key: string;
    value: number;
    // icon: React.ReactElement;
  }[];
}

export default function CustomerCategorized({ title, subheader, list, ...other }: Props) {
  const { translate } = useLocales();
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: 'repeat(2, 1fr)',
          }}
        >
          {list?.map((site) => (
            <Paper key={site.key} variant="outlined" sx={{ py: 2.5, textAlign: 'center' }}>
              <Box sx={{ mb: 0.5 }}>
                {' '}
                {site.id === 0 ? (
                  <CheckCircleIcon sx={{ fontSize: 50, color: 'green' }} />
                ) : (
                  <DoNotDisturbOnIcon sx={{ fontSize: 50, color: 'error.main' }} />
                )}
              </Box>

              <Typography variant="h6">{fShortenNumber(site.value)}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {site.key === 'ContractFullCustomer'
                  ? translate('Dashboards.ContractFullCustomer')
                  : translate('Dashboards.ContractLessCustomer')}
              </Typography>
            </Paper>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
